import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { storeToolkit } from './app/store';
import App from './App';
import { StyledToastContainer } from './components/common/Toasts/ToastsStyled';
import { chooseTheme, GlobalStyles } from './styles/GlobalStyles';
import 'react-toastify/dist/ReactToastify.min.css';
import './index.css';
import './i18n';

import { WagmiProvider } from 'wagmi';

import { createAppKit } from '@reown/appkit/react';
import { bsc } from '@reown/appkit/networks';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const projectId = '2ecc3262ca51da051900c4cbd03890f7';

const metadata = {
  name: `Big Hearts`,
  description: `Big Heart app`,
  url: `https://backoffice.bighearts.global`,
  icons: [`https://avatars.githubusercontent.com/u/37784886`]
};

export const chains = [bsc] as const;

const wagmiAdapter = new WagmiAdapter({
  networks: [bsc],
  projectId
});

createAppKit({
  adapters: [wagmiAdapter],
  networks: [bsc],
  metadata: metadata,
  projectId,
  features: {
    analytics: true
  }
});

const container: any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <WagmiProvider config={wagmiAdapter.wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <Provider store={storeToolkit}>
        <ThemeProvider theme={chooseTheme}>
          <GlobalStyles />
          <StyledToastContainer />
          <App />
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  </WagmiProvider>
);
